import { useEffect, useRef } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Subscribe to the shared real-time channel (Server-Sent Events).
 * audience: "command" | "field" | "public".
 * onEvent({ type, payload }) fires on every server push.
 * Auto-reconnects; HTTP polling elsewhere remains the fallback.
 */
export function useLiveStream(audience, onEvent) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    let es;
    let retry;
    let closed = false;

    const connect = () => {
      if (closed || !audience) return;
      es = new EventSource(`${API}/stream?audience=${audience}`);
      es.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          cbRef.current && cbRef.current(data);
        } catch (_) {}
      };
      es.onerror = () => {
        es.close();
        if (!closed) retry = setTimeout(connect, 3000); // reconnect
      };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      es && es.close();
    };
  }, [audience]);
}
